import "./ProgressiveImage.css";
import NoImageFound from "../../assets/images/fallback/transparent_picture.png";
import { LazyLoadImage } from "react-lazy-load-image-component";
import placeHolderImage from "../../assets/icons/product_placeholder.svg";

const ProgressiveImg1 = ({ placeholderSrc, src, ...props }) => {
  return (
    <div class="imagesContainer">
      <img src={placeholderSrc} alt="" />
      <img
        class="fadeInClass"
        src={src}
        alt=""
        onError={(e) => {
          e.target.src = NoImageFound;
        }}
      />
    </div>
  );
};

const ProgressiveImg = ({
  placeholderSrc = placeHolderImage,
  src,
  ...props
}) => {
  return (
    <div
      className="imagesContainer"
      style={{
        width: props?.style?.width || "100%",
        height: props?.style?.height || "100%",
        ...props?.style
      }}
    >
      <LazyLoadImage
        alt={""}
        //height={image.height}
        src={src || placeholderSrc}
        //width={image.width}
        style={props.style}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = placeholderSrc;
        }}
      />
    </div>
  );
};

export default ProgressiveImg;
